import React, { useState } from "react";
import { IoChevronBack } from "react-icons/io5";
import logo from "../../images/ic-password.png";
import logo1 from "../../images/LogoDashboard.png";

import AuthButton from "../../Components/AuthButton/AuthButton";
import { useNavigate } from "react-router-dom";
import Input from "../../Components/Input/Input";
import { useDispatch } from "react-redux";
import { postForgetPass } from "../../Actions/actions";
import Loader from "../../Components/Loader/Loader";
import { useSelector } from "react-redux";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({ email: "" });
  const dispatch = useDispatch();

  const { loader } = useSelector((state) => state.userReducer);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const validateForm = () => {
    let valid = true;
    let errors = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      errors.email = "Please enter a valid email address";
      valid = false;
    }
    setErrors(errors);
    return valid;
  };
  const handleSubmit = () => {
    if (validateForm()) {
      dispatch(
        postForgetPass(email, () => {
          navigate("/resend", { state: { email } });
        })
      );
    }
  };
  return (
    <div className="font-public min-h-screen flex flex-col items-center justify-center bg-white">
      <div className="absolute top-10 left-10">
        <img src={logo1} alt="Repotal Logo" className="w-[200px] h-auto" />
      </div>

      <div className="mb-6">
        <img src={logo} alt="Repotal Logo" className="w-20 h-auto" />
      </div>

      <h2 className="text-2xl font-semibold text-center text-[#361D32] mb-4">
        Forgot your password?
      </h2>
      <p className="text-sm text-center text-gray-600 mb-6 w-[82.5%]  md:w-[50%]   lg:w-[38%]  sm:w-[60%] xl:w-[27.5%]">
        Please enter the email address associated with your account, and we'll
        email you a link to reset your password.
      </p>
      <div className="w-[380px] mb-4">
        <Input
          float={true}
          label={"Email Address"}
          placeholder={"Email Address"}
          value={email}
          onChange={handleEmailChange}
          error={errors.email}
        />
      </div>
      {loader ? (
        <div className="p-4">
          <Loader />
        </div>
      ) : (
        <AuthButton
          className="text-white"
          onClick={() => {
            handleSubmit();
          }}
          title={"Send Request"}
        />
      )}

      <div
        onClick={() => {
          navigate("/");
        }}
        className="flex items-center text-purple-900 font-medium cursor-pointer"
      >
        <IoChevronBack className="mr-1 text-black" />
        <p className="text-[#361D32]">Return to sign in</p>
      </div>
    </div>
  );
}
